import IconEyeSlashSolid from '@/assets/icons/font_awesome/eye-slash-solid.svg?react';
import IconEyeSolid from '@/assets/icons/font_awesome/eye-solid.svg?react';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { RequestTokensUpdateVisibility } from '@shared/common/_requests/request_tokens_update_visibility';
import { DTO__token } from '@shared/dto/generation/settings/token/DTO__token';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__button_with_icon_animated } from '../../../components/ui/UI_PRIMITIVE__button_with_icon_animated';

interface Props {
  item: DTO__token;
  entity_id: string;
  required_permission: string;
  send_request: (request: RequestTokensUpdateVisibility) => void;
}

export function ButtonTokenUpdateVisibility({ item, entity_id, send_request, required_permission }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  function onClick() {
    item = item.clone({ is_hidden: !item.is_hidden });

    let request = new RequestTokensUpdateVisibility(entity_id);
    request.tokens = [item];

    send_request(request);
  }

  if (!current_workspace_user.is_feature_pertmitted(required_permission)) return <></>;

  return (
    <UI_PRIMITIVE__tooltip
      tooltip_title={item.is_hidden ? t(i18n_base_ui.button.token_visibility.tooltip_show) : t(i18n_base_ui.button.token_visibility.tooltip_hide)}
    >
      <UI_PRIMITIVE__button_with_icon_animated
        variant="no-border-on-component"
        size="icon"
        onClick={onClick}
        iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
        iconClassNameHovered="!text-bar-foreground"
        Icon={item.is_hidden ? IconEyeSolid : IconEyeSlashSolid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
